import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { rejectSurvey } from '../Services/Surveys.service';
import { useActionToast } from '@/Hooks/useActionToast';

export const useRejectSurvey = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason: string }) => rejectSurvey(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.details() });
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
      toast.success('Pesquisa rejeitada', 'Quem enviou vê o motivo no construtor.');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível rejeitar a pesquisa', error);
    },
  });
};
